export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#80B622',
    light: '#F7F8F8',
    after: '#6B5A9A',
    contrastText: '#FFFFFF',
    brand: '#80B622',
  },
  secondary: {
    main: '#FFFFFF',
    light: 'rgba(255, 255, 255, 0.2)',
    contrastText: '#22211F',
  },
  text: {
    content: '#25272C',
    brand: '#003F2A',
    brandHero: '#3C4B1E',
    button: '#0C0F06',
    primary: '#001A11',
    secondary: '#3E444E',
    tertiaryLight: '#49515B',
    tertiary: '#7C8694',
    alternate: '#1F3B61',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
    contrastText: '#22211F',
    brandBorder: '#D2AB4F',
    blueBorder: '#6E93A3',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    brandLight: '#003964',
    benefits: '#FDFFF9',
    benefitsCard: '#EBE8E5',
    heroInner: '#FDFFF9',
    heroOuter: '#D2AB4F',
    tabActive: 'rgba(237, 234, 232, 0.8)',
    dark: '#80B622',
    hero1: '#06343D',
    heroOverlay: 'rgba(6, 52, 61, 0.8)',
    // heroGradient:
    //   'linear-gradient(178deg, rgba(6, 52, 61, 0) 16%, rgba(6, 52, 61, 0.8) 96%)',
    main: '#FFFFFF',
    paper: '#FFF',
    default: '#FFF',
    header: '#4E4E4E',
    footer: '#1C2B0A',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#679818',
    tableSubhead: '#F7F8F8',
    tableBorder: '#7D808880',
    tableAlternate: '#FFFFFF',
    alternate: '#E5EAF4',
    success: '#DBEFDC',
    error: '#FFEAEA',
    primary: '#B6BFA5',
    secondary: '#F5F3F0',
    light: '#EDE7DE',
    secondaryLight: 'rgba(238, 246, 250, 0.6)',
    primaryLight: '#D9EDF7',
    ribbon: '#BBE6FE',
    offer: '#D7FFF7',
    stepperCompleted: '#081425',
    border: '#D7DBE0',
    buttonTertiary: '#EDEEF1',
  },
  surface: {
    light: '#B6BFA5',
    grey: '#FAFAFA',
    pricing:
      '#405C18',
    learnMore: '#F4F4F4',
    header: '#FAFAFA',
    planCard: '#F7F8F8',
    switch: '#313E50',
  },
  verticalBar: {
    used: '#687462',
    unused: '#F6F6F6',
    unlimited: '#C0C0C0',
  },
};
